import { actions } from 'data'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import SignoutSessions from './template'

export type PropsType = ConnectedProps<typeof connector>

const SignoutSessionsContainer = (props) => <SignoutSessions {...props} signout={() => {}} />

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => {
    dispatch(actions.app.hideModal('SIGNOUT_SESSIONS'))
  }
})

const connector = connect(null, mapDispatchToProps)

export default connector(SignoutSessionsContainer)
